import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const bgClass = background === 'white' ? 'bg-white' : 'bg-[#F5F0E8]';
  return <section id={id} className={`py-16 md:py-24 px-4 md:px-6 ${bgClass} ${className}`} data-id="element-4">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto" data-id="element-5">
        {children}
      </motion.div>
    </section>;
}